import { numericUtil } from '@cmg/common';

import type {
  ParticipationReportGridColDef,
  ParticipationReportGridValueFormatterFunc,
  ParticipationReportRecord,
} from '../../types';

export type Value = ParticipationReportRecord['fillRate'];

export const valueFormatter: ParticipationReportGridValueFormatterFunc<Value> = ({ value }) => {
  return numericUtil.getDisplayValueForPercents(value, 2);
};

export const fillRateColDef: ParticipationReportGridColDef<Value> = {
  field: 'fillRate',
  headerName: 'Fill Rate',
  valueFormatter,
  type: ['numericColumn', 'number'],
  width: 137,
  filter: false, // TODO: Re-enable filter when we add percentage filtering support to ag-grid SSRM
  // filter: 'agNumberColumnFilter',
  // floatingFilter: true,
};
